import React from 'react';
import { stats, features } from '../mock/data';

const Details = () => (
  <section id="details" className="relative bg-white py-24 md:py-32">
    <div className="max-frame container-px">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-[var(--line)] rounded-[6px] overflow-hidden border border-[var(--line)]">
        {stats.map((s) => (
          <div key={s.label} className="reveal bg-white p-8 md:p-10">
            <div className="flex items-baseline gap-1.5">
              <span className="font-display text-[clamp(2.6rem,6vw,4.6rem)] leading-none text-[var(--ink)]">{s.value}</span>
              {s.suffix && <span className="font-display text-[var(--accent)] text-xl md:text-2xl">{s.suffix}</span>}
            </div>
            <p className="mt-3 text-[var(--muted)] text-sm uppercase tracking-[0.1em]">{s.label}</p>
          </div>
        ))}
      </div>

      <div className="mt-20 grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-12">
        {features.map((f) => (
          <div key={f.no} className="reveal border-t border-[var(--line)] pt-7">
            <div className="flex items-start gap-6">
              <span className="font-display text-xl text-[var(--accent)] shrink-0">{f.no}</span>
              <div>
                <h3 className="text-xl md:text-2xl font-semibold font-tight">{f.title}</h3>
                <p className="mt-3 text-[var(--muted)] leading-relaxed max-w-[460px]">{f.text}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Details;
